import { times, always } from 'ramda';
export const pad = (value = '', count = 0) => {
  const valueStr = value.toString();
  const diff = count - valueStr.length;
  if (diff < 0) {
    return valueStr;
  }
  return `${times(always(0), diff).join('')}${valueStr}`;
};
export const formattedValue = (value, delimiter = ' ') => value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, `$1${delimiter}`);